<form [formGroup]="form.formGroup">
  <svg-icon src="../../assets/icons/reset-default-24x24.svg" class="w-[25px] h-[25px] mb-2 tree-icon" (click)="applyDefaults()" title="Apply Defaults"></svg-icon>
  <div class="grid grid-cols-1 md:grid-cols-2 items-start">
    <!-- Left Column -->
    <div class="p-4">
      <div class="flex flex-col gap-4">
        <div class="flex flex-col">
          <label for="a0" class="mb-1">a0 x 10<span class="text-xs align-super">4</span></label>
          <app-validated-number-input
            [id]="'a0'"
            [control]="control('a0')"
            [value]="control('a0').value"
            [validation]="{ min: 0, max: 10000000 }"
            [unit]="''"
          ></app-validated-number-input>
        </div>

        <div class="flex flex-col">
          <label for="a1" class="mb-1">a1 x 10<span class="text-xs align-super">8</span></label>
          <app-validated-number-input
            [id]="'a1'"
            [control]="control('a1')"
            [value]="control('a1').value"
            [validation]="{ min: 0, max: 10000000 }"
            [unit]="''"
          ></app-validated-number-input>
        </div>

        <div class="flex flex-col">
          <label for="a2" class="mb-1">a2 x 10<span class="text-xs align-super">13</span></label>
          <app-validated-number-input
            [id]="'a2'"
            [control]="control('a2')"
            [value]="control('a2').value"
            [validation]="{ min: 0, max: 10000000 }"
            [unit]="''"
          ></app-validated-number-input>
        </div>
      </div>
    </div>

    <!-- Right Column -->
    <div class="p-4">
      <div class="flex flex-col gap-4">
        <div class="flex flex-col">
          <label for="b0" class="mb-1">b0 x 10</label>
          <app-validated-number-input
            [id]="'b0'"
            [control]="control('b0')"
            [value]="control('b0').value"
            [validation]="{ min: 0, max: 10000000 }"
            [unit]="''"
          ></app-validated-number-input>
        </div>

        <div class="flex flex-col">
          <label for="b1" class="mb-1">b1 x 10<span class="text-xs align-super">6</span></label>
          <app-validated-number-input
            [id]="'b1'"
            [control]="control('b1')"
            [value]="control('b1').value"
            [validation]="{ min: 0, max: 10000000 }"
            [unit]="''"
          ></app-validated-number-input>
        </div>

        <div class="flex flex-col">
          <label for="b2" class="mb-1">b2 x 10<span class="text-xs align-super">12</span></label>
          <app-validated-number-input
            [id]="'b2'"
            [control]="control('b2')"
            [value]="control('b2').value"
            [validation]="{ min: 0, max: 10000000 }"
            [unit]="''"
          ></app-validated-number-input>
        </div>
      </div>
    </div>
  </div>

</form>
